// extracted by mini-css-extract-plugin
export default {"wrapper":"Scrollbars-module__wrapper"};